<!--
 * @Author: M.D.
 * @Date: 2019-12-30 10:53:38
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="toggle-loc-w">
    <div class="tl-outer-w" @click="locationDialog = !locationDialog">
      <span class="iconfont icon-lbs" style="padding-right:4px"></span>
      <span>{{areaTxt === '' ? '选择地点': areaTxt}}</span>
      <span class="iconfont icon-arrow-down"></span>
    </div>

    <!-- 地址切换Dialog -->
    <el-dialog
      :close-on-click-modal="false"
      ref="loginDialog"
      :visible.sync="locationDialog"
      class="loca-dialog"
      @open="areaCodeArr = curLoc"
      width="24%">
      <div slot="title" class="tp-loca-dialog-title">
        <span class="tp-loca-dh-img-w">
          <img src="@/assets/image/toggle-location-icon.png" alt="">
        </span>
        <span>更改所在地</span>

      </div>
      <div class="loca-cascader">
        <!-- <el-cascader
          ref="tgLocCas"
          v-if="!city"
          style="width:300px;"
          v-model="areaCodeArr"
          :options="locaOptions"
          :props="{ checkStrictly: true }"
          @visible-change="vchange"
          @change="handleChange">
        </el-cascader> -->
        <el-cascader
          ref="tgLocCas"
          style="width:300px;"
          v-model="areaCodeArr"
          :options="locaOptions"
          @visible-change="vchange"
          @change="handleChange">
        </el-cascader>
      </div>
      <div slot="footer" class="tp-loca-dialog-footer">
        <el-button size="small" type="success" @click="confirm">确定</el-button>
        <el-button size="small" plain @click="reset">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { cityData, getCityTxt } from '@/util/area'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
  },
  data () {
    return {
      locationDialog: false,
      areaCodeArr: ['510000', '510100'],
      locaOptions: []
    }
  },
  computed: {
    ...mapGetters(['curLoc']),
    areaTxt () {
      if (this.curLoc.length === 0) {
        return '请选择地区'
      } else {
        return getCityTxt(this.curLoc)
      }
    }
  },
  created () {
    this.locaOptions = this._.cloneDeep(cityData)
  },
  mounted () {
    this.setCurLoc(this.areaCodeArr)
  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    ...mapActions(['setCurLoc']),
    handleChange (v) {
      // if (v.length >= 2) {
      this.areaCodeArr = v
      // }
    },
    vchange (v) {
      // console.log(this.areaCodeArr) // 不准
      this.$nextTick(() => {
        // console.log(this.areaCodeArr) // 准确
        // if (!v) {
        //   this.locaOptions = this._.cloneDeep(areaData)
        // }
      })
    },
    confirm () {
      if (!this._.isEmpty(this.areaCodeArr)) {
        console.log(this.areaCodeArr)
        this.setCurLoc(this.areaCodeArr)
      }

      // 其他组件页面可以 watch 地区变化
      this.locationDialog = false
    },
    reset () {
      // this.areaCodeArr = []
      // this.setCurLoc([])
      this.locationDialog = false
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.toggle-loc-w
  .tl-outer-w
    .icon-arrow-down
      font-size 12px
      padding-left 6px
  .loca-dialog
    color #000000
    .tp-loca-dialog-title
      display flex
      align-items center
      font-size 14px
      .tp-loca-dh-img-w
        img-wrapper()
        height 20px
        width 20px
        margin-right 6px
        img
          display inline-block
          height 20px
          width 100%
    .loca-cascader
      center()
  .tp-loca-dialog-footer
    .l
      color black
</style>
